import React, { Component, PureComponent } from 'react'
import BEMHelper from '@ynap/bem-helper'
import PropTypes from 'prop-types'
import { Button } from '@ynap/button'

const bem = new BEMHelper('CustomerCare')

export class Section extends Component {
    render() {
        const { type, imageClassName, title, details, link, linkText, children, locale } = this.props

        const sectionContent = (
            <>
                <div className={bem('image', imageClassName)} />
                <div className={bem('title')}>{title}</div>
                {details ? <div className={bem('details')}>{details}</div> : null}
                {link && linkText ? (
                    <Button
                        type="link"
                        component="a"
                        href={`/${locale.id}${link}`}
                        rel="noopener"
                        className={bem('link')}
                    >
                        {linkText}
                    </Button>
                ) : null}
                {children}
            </>
        )

        return link && !linkText ? (
            <a href={`/${locale.id}${link}`} className={bem('section', type)}>
                {sectionContent}
            </a>
        ) : (
            <div className={bem('section', type)}>{sectionContent}</div>
        )
    }
}

export default class CustomerCare extends Component {
    constructor(props) {
        super(props)
        this.state = { contactInfo: undefined }
    }

    static propTypes = {
        messages: PropTypes.shape({
            customerCare: PropTypes.shape({
                service: PropTypes.func.isRequired,
                customerCare: PropTypes.func.isRequired,
                returns: PropTypes.func.isRequired,
                delivery: PropTypes.func.isRequired,
                callUs: PropTypes.func.isRequired,
                emailUs: PropTypes.func.isRequired,
            }),
        }),
    }

    componentDidMount() {
        if (window && window.SF && window.SF.getContactDetails) {
            const contactDetails = window.SF.getContactDetails()

            if (contactDetails?.customerCare) {
                this.setState({ contactInfo: contactDetails.customerCare })
            }
        }
    }

    render() {
        const { messages, links, locale } = this.props
        const { customerCare } = messages
        const { contactInfo } = this.state

        return (
            <div className={bem('container')} id="CustomerCare">
                <div className={bem('line')} />
                {customerCare.service && <div className={bem('service')}>{customerCare.service()}</div>}
                {links?.apps && (
                    <Section
                        type="apps"
                        imageClassName="appsImage"
                        title={customerCare.apps?.()}
                        details={customerCare.appsDetails?.()}
                        link={links.apps}
                        linkText={customerCare.appsLink?.()}
                        locale={locale}
                    />
                )}
                {links?.contactHelp ? (
                    <Section
                        type="contact"
                        imageClassName="phoneImage"
                        title={customerCare.customerCare?.()}
                        details={customerCare.customerCareDetails?.()}
                        link={links.contactHelp}
                        linkText={customerCare.customerCareLink?.()}
                        locale={locale}
                    />
                ) : (
                    <Section
                        type="contact"
                        imageClassName="phoneImage"
                        locale={locale}
                        title={customerCare.customerCare?.()}
                        details={customerCare.customerCareDetails?.()}
                    >
                        <div className={bem('contact')}>
                            <Button
                                type="link"
                                component="a"
                                href={'tel:' + contactInfo?.telephone}
                                rel="noopener"
                                className={bem('callus')}
                            >
                                {customerCare.callUs?.()}
                            </Button>
                            <Button
                                type="link"
                                component="a"
                                href={'mailto:' + contactInfo?.email}
                                rel="noopener"
                                className={bem('emailus')}
                            >
                                {customerCare.emailUs?.()}
                            </Button>
                        </div>
                    </Section>
                )}
                <Section
                    type="returns"
                    imageClassName="returnsImage"
                    title={customerCare.returns?.()}
                    details={customerCare.returnsDetails?.()}
                    link={links?.returnsHelp}
                    linkText={customerCare.returnsLink?.()}
                    locale={locale}
                />
                <Section
                    type="shipping"
                    imageClassName="deliveryImage"
                    title={customerCare.delivery?.()}
                    details={customerCare.deliveryDetails?.()}
                    link={links?.deliveryHelp}
                    linkText={customerCare.deliveryLink?.()}
                    locale={locale}
                />
            </div>
        )
    }
}
